import { call, put, takeEvery } from 'redux-saga/effects'
import {
  // Store Type
  getOrderListApiData,
  getOrderListApiDataSuccess,
  getOrderListApiDataFailed,

  // add Store Type
  getOrderListDetailsListApiData,
  getOrderListDetailsListApiSuccess,
  getOrderListDetailsListApiFailed,
} from './slice'
import { API } from '../../services'

//Pharmacy Admin

function* getOrderListApi({ type, payload }) {
  try {
    const response = yield call(API.orderManageMent.getOrderList, payload)
    if (response.data && response.status === 200) {
      yield put(getOrderListApiDataSuccess({ payload: response?.data }))
    } else {
      yield put(getOrderListApiDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getOrderListApiDataFailed({ message: error?.message }))
  }
}
function* getOrderListDetailsListApi({ type, payload }) {
  try {
    const response = yield call(API.orderManageMent.getOrderListDetailsList, payload)
    if (response.data && response.status === 200) {
      yield put(getOrderListDetailsListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getOrderListDetailsListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getOrderListDetailsListApiFailed({ message: error?.message }))
  }
}

function* orderManageMent() {
  yield takeEvery(getOrderListApiData, getOrderListApi)
  yield takeEvery(getOrderListDetailsListApiData, getOrderListDetailsListApi)
}

export default orderManageMent
